import { create } from 'zustand'
import { apiClient, ApiError } from '../lib/api'
import { resetAnalytics, track } from '../lib/analytics'
import type { User, UserProfile } from '../lib/types'

interface AuthState {
  user: User | null
  loading: boolean
  error: string | null
  fetchUser: () => Promise<void>
  logout: () => Promise<void>
  updateProfile: (data: Partial<UserProfile>) => Promise<void>
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,
  error: null,

  fetchUser: async () => {
    try {
      set({ loading: true, error: null })
      const user = await apiClient.get<User>('accounts/auth/user/')
      set({ user, loading: false })
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        set({ user: null, loading: false })
      } else {
        set({ error: 'Failed to load user', loading: false })
      }
    }
  },

  logout: async () => {
    track('logout')
    await apiClient.post('accounts/auth/logout/')
    resetAnalytics()
    set({ user: null })
  },

  updateProfile: async (data) => {
    const profile = await apiClient.patch<UserProfile>('accounts/profile/', data)
    set((state) => ({
      user: state.user ? { ...state.user, profile } : null,
    }))
  },
}))
